/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M6.57 3.38V2.2c0-.66.55-1.2 1.22-1.2H9.4c.67 0 1.22.54 1.22 1.2v1.1a6 6 0 0 1 2 1.1l.93-.53a1.23 1.23 0 0 1 1.66.44l.82 1.38c.33.58.13 1.31-.45 1.64l-.9.52a6 6 0 0 1 0 2.3l.9.52c.58.33.78 1.06.45 1.64l-.82 1.38c-.33.57-1.08.77-1.66.44l-.94-.53a6 6 0 0 1-1.99 1.1v1.1c0 .66-.55 1.2-1.22 1.2H7.8a1.2 1.2 0 0 1-1.22-1.2v-1.18a6 6 0 0 1-1.86-1.1l-1.07.61c-.58.33-1.33.13-1.66-.44l-.82-1.38a1.2 1.2 0 0 1 .45-1.64l1.1-.63a6 6 0 0 1 0-2.08l-1.1-.63a1.2 1.2 0 0 1-.45-1.64l.82-1.38a1.23 1.23 0 0 1 1.66-.44l1.07.6a6 6 0 0 1 1.86-1.09",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M8.6 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            })
        ]
    }));
};
export default SvgComponent;
